module.exports = __webpack_public_path__ + "static/media/logos-fr.bfe818c0.png";